import { render, staticRenderFns } from "./QuickScoringPanel.vue?vue&type=template&id=052154a7&scoped=true"
import script from "./QuickScoringPanel.vue?vue&type=script&lang=js"
export * from "./QuickScoringPanel.vue?vue&type=script&lang=js"
import style0 from "./QuickScoringPanel.vue?vue&type=style&index=0&id=052154a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052154a7",
  null
  
)

export default component.exports